import { AggregateAwaAnalysis } from '@blk/awt-aladdinportfoliobuilderserver';

export const mutateProposedAwaAnalysisBenchmarkData = (
  original: AggregateAwaAnalysis,
  proposed: AggregateAwaAnalysis
) => {
  if (proposed.aggregate && original.aggregate) {
    if (!proposed.aggregate.totalPortfolio.benchmark) {
      // Copy over totalPortfolio data at aggregate level if it's missing from benchmark
      proposed.aggregate.totalPortfolio.benchmark = original.aggregate?.totalPortfolio.benchmark;
    }

    // Copy over sleeve data at aggregate level if it's missing from benchmark
    const aggregateSleeveKeys = Object.keys(proposed.aggregate.sleeves);
    aggregateSleeveKeys.forEach((aggregateSleeveKey) => {
      const sleeve = proposed.aggregate?.sleeves[aggregateSleeveKey];
      if (sleeve && !sleeve.benchmark) {
        sleeve.benchmark = original.aggregate?.sleeves[aggregateSleeveKey]?.benchmark;
      }
    });

    // Copy over totalPortfolio data at portfolio level if it's missing from benchmark
    proposed.portfolios.forEach((portfolio, i) => {
      if (!portfolio.totalPortfolio.benchmark) {
        portfolio.totalPortfolio.benchmark = original.portfolios[i]?.totalPortfolio.benchmark;
      }

      // Copy over sleeve data at portfolio level if it's missing from benchmark
      const portfolioSleeveKeys = Object.keys(portfolio.sleeves);
      portfolioSleeveKeys.forEach((portfolioSleeveKey) => {
        const sleeve = portfolio.sleeves[portfolioSleeveKey];
        if (sleeve && !sleeve.benchmark) {
          sleeve.benchmark = original.portfolios[i]?.sleeves[portfolioSleeveKey]?.benchmark;
        }
      });
    });
  }

  // Copy over benchmark data at mid-level aggregate level if it's missing
  proposed.midLevelAggregates.forEach((mla, i) => {
    const originalMla = original.midLevelAggregates[i];
    if (mla.analysis && originalMla?.analysis) {
      if (!mla.analysis.totalPortfolio.benchmark) {
        mla.analysis.totalPortfolio.benchmark = originalMla.analysis.totalPortfolio.benchmark;
      }

      // Copy over sleeve data at mid-level aggregate level if it's missing from benchmark
      const sleeveKeys = Object.keys(mla.analysis.sleeves);
      sleeveKeys.forEach((sleeveKey) => {
        const sleeve = mla.analysis.sleeves[sleeveKey];
        if (sleeve && !sleeve.benchmark) {
          sleeve.benchmark = originalMla.analysis.sleeves[sleeveKey]?.benchmark;
        }
      });
    }
  });
};
